export default "__VITE_ASSET__DKAoDTvE__"